import { BaseModel } from '@hds/help-common/src/models/base-model'

type MenuBase = BaseModel

export interface Menu extends MenuBase {
  // TODO 정리 필요
  /**
   * 메뉴 아이디
   */
  menuId?: string
  /**
   * 메뉴명
   */
  menuNm?: string
  /**
   * 메뉴단계
   */
  menuLvl?: string
  lvlPrty?: string
  /**
   * 상위 메뉴
   */
  highMenuId?: string
  logMngYn?: string
  /**
   * 시스템 코드 & 명
   */
  sysGbcd?: string
  sysGbnm?: string

  /**
   * 메뉴경로
   */
  prgUrl?: string
  /**
   * 마지막 메뉴 여부
   */
  isleaf?: string
  psnInfInclYn?: string
  qryCondLogYn?: string
  userId?: string
}

export type MenuTree = Menu & {
  /**
   * 하위 메뉴
   */
  items?: MenuTree[]
}

export function findMenuById(menus: MenuTree[], menuId: string): MenuTree {
  if (!menus) {
    return null
  }

  for (const menu of menus) {
    if (menu.menuId === menuId) return menu

    const subMenu = this.findMenuById(menu.items, menuId)
    if (subMenu) return subMenu
  }
}

export function findMenuByUrl(menus: MenuTree[], url: string): MenuTree {
  if (!menus) {
    return null
  }

  for (const menu of menus) {
    if (menu.prgUrl === url) return menu

    const subMenu = this.findMenuByUrl(menu.items, url)
    if (subMenu) return subMenu
  }
}
